import { render, staticRenderFns } from "./RedeemCoupon.vue?vue&type=template&id=189175ef&scoped=true&"
import script from "./RedeemCoupon.vue?vue&type=script&lang=js&"
export * from "./RedeemCoupon.vue?vue&type=script&lang=js&"
import style0 from "./RedeemCoupon.vue?vue&type=style&index=0&id=189175ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189175ef",
  null
  
)

export default component.exports